import { render, staticRenderFns } from "./ListaInterazioni.vue?vue&type=template&id=12dd1d72&scoped=true"
import script from "./ListaInterazioni.vue?vue&type=script&lang=js"
export * from "./ListaInterazioni.vue?vue&type=script&lang=js"
import style0 from "./ListaInterazioni.vue?vue&type=style&index=0&id=12dd1d72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dd1d72",
  null
  
)

export default component.exports